// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1RcYl","imageUploader":"EGiftCard_imageUploader__3_NpB"};